import { render, staticRenderFns } from "./TaksitTutarinaGoreTaksitlendirme.vue?vue&type=template&id=09865932&scoped=true"
import script from "./TaksitTutarinaGoreTaksitlendirme.vue?vue&type=script&lang=ts"
export * from "./TaksitTutarinaGoreTaksitlendirme.vue?vue&type=script&lang=ts"
import style0 from "./TaksitTutarinaGoreTaksitlendirme.vue?vue&type=style&index=0&id=09865932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09865932",
  null
  
)

export default component.exports